import React, { useEffect } from "react";
import JumbotronPage from "../components/JumbotronPage";
import SectionContainer from "../layouts/SectionContainer";
import AboutYoungCompany from "../components/PresentationContainer";
import BranchActivityContainer from "../components/BranchActivityContainer";

import NewProjectContextProvider from "../context/NewProjectContext";


const Home = () => {
  useEffect(() => {
    document.title = "Cartésia Junior";
  }, []);

  const presentation =
    "... Offrir l'opportunité aux étudiants les plus talentueux de notre campus de faire un premier pas dans le monde professionnel, en vous proposant des prestations lié à nos domaines d'études. Que vous soyez une entreprise, un particulier ou une association, nous sommes déterminés à réaliser votre projet avec expertise et dévouement !";

  return (
    <NewProjectContextProvider>
      <JumbotronPage />
      <div className="section-container">
        <SectionContainer color="#F4F4F4">
          <AboutYoungCompany
            title="Notre mission ?"
            about={presentation}
            img="studentsCreatingProject.jpg"
          />
        </SectionContainer>
        <SectionContainer>
          <BranchActivityContainer />
        </SectionContainer>
      </div>
    </NewProjectContextProvider>

  );
};

export default Home;
